import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line react/display-name
const AIBotAvatarIcon = ({
  width = 48,
  height = 48,
  color
}) => /*#__PURE__*/_jsxs("svg", {
  width: width,
  height: height,
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "#DFE3EB",
    stroke: color
  }), /*#__PURE__*/_jsxs("g", {
    clipPath: "url(#clip0_5535_8660)",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M27.7228 20.4728L26.3128 23.0453C25.7053 24.1478 24.7978 25.0628 23.6953 25.6628L21.1228 27.0728C20.7178 27.2978 20.7178 27.8828 21.1228 28.1003L23.6953 29.5028C24.8053 30.1103 25.7128 31.0178 26.3203 32.1278L27.7303 34.7003C27.9553 35.1053 28.5403 35.1053 28.7578 34.7003L30.1678 32.1278C30.7753 31.0253 31.6828 30.1103 32.7853 29.5103L35.3578 28.1003C35.7628 27.8753 35.7628 27.2903 35.3578 27.0728L32.7853 25.6628C31.6828 25.0553 30.7678 24.1478 30.1678 23.0453L28.7578 20.4728C28.5328 20.0678 27.9478 20.0678 27.7303 20.4728H27.7228Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.3353 12.2228L16.3153 14.0828C15.8803 14.8853 15.2203 15.5453 14.4178 15.9803L12.5578 17.0003C12.2653 17.1653 12.2653 17.5853 12.5578 17.7503L14.4178 18.7703C15.2203 19.2053 15.8803 19.8653 16.3153 20.6678L17.3353 22.5278C17.5003 22.8203 17.9203 22.8203 18.0853 22.5278L19.1053 20.6603C19.5403 19.8578 20.2003 19.1978 21.0028 18.7628L22.8628 17.7428C23.1553 17.5778 23.1553 17.1578 22.8628 16.9928L21.0028 15.9728C20.2003 15.5378 19.5403 14.8778 19.1053 14.0753L18.0853 12.2153C17.9203 11.9228 17.5003 11.9228 17.3353 12.2153V12.2228Z",
      fill: color
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_5535_8660",
      children: /*#__PURE__*/_jsx("rect", {
        width: 24,
        height: 24,
        fill: "white",
        transform: "translate(12 11.5)"
      })
    })
  })]
});
export default AIBotAvatarIcon;